<template>
  <div>
    <div class="main-wrapper">
      <div>
        <!-- <layout-header3></layout-header3> -->
        <layout-header></layout-header>
        <!-- Breadcrumb -->
        <div class="breadcrumb-bar" style="background-color: #3CB371;">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-12 col-12">
                <nav aria-label="breadcrumb" class="page-breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/index">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Medical Records
                    </li>
                  </ol>
                </nav>
                <h3 class="breadcrumb-title">Medical Records</h3>
              </div>
            </div>
          </div>
        </div>
        <!-- /Breadcrumb -->
        <!-- Page Content -->
        <div class="content">
          <div class="container">
            <div class="row">
              <!-- Profile Sidebar -->
              <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <sidebar1></sidebar1>
              </div>

              <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                <loader></loader>
              </div>
              <!-- / Profile Sidebar -->
              <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                <div class="row ml-md-3" id="patient_container">
                  <div class="col-sm-12">
                    <!-- <h3 class="mb-3 mt-2">My Medical Records</h3> -->
                    <div class="card">
                      <div class="card-body pt-0">
                        <!-- Tab Content -->
                        <div class="tab-content pt-0">
                          <!-- Medical Records Tab -->
                          <div id="pat_medicalrecords" class="tab-pane fade show active">
                            <div class="text-left">
                              <a href="#" class="btn btn-primary mt-2" data-toggle="modal"
                                data-target="#add_medical_records_modal">Add Medical Record
                              </a>
                            </div>
                            <div class="row mt-3">
                              <div class="card border-0 col-lg-4" v-for="(item, index) in medical_records" :key="index"
                                v-show="setPaginate(index)">
                                <div class="card-body border" style="
                                    border-radius: 26px;
                                    border-color: #00b3d0 !important;
                                    margin-bottom: 20px;
                                  ">
                                  <div class="row">
                                    <div class="col-6">
                                      <img style="width: 70px" class="avatar-img" v-bind:src="config.base_url_for_Image + item.image
                                        " alt="User Image" />
                                      <p class="mt-1
                                          card-subtitle
                                          text-muted
                                        ">
                                        {{
                                          item.report_type
                                          ? item.report_type
                                          : "-"
                                        }}
                                      </p>
                                    </div>
                                    <div class="col-6">
                                      <div class="message">
                                        <h5 class="card-title">
                                          {{ item.doctor_name ? item.doctor_name : "-" }}
                                        </h5>
                                        <h6 class="card-subtitle mb-2 text-muted">
                                          {{ item.date ? formatDate(item.date) : "-" }}
                                        </h6>
                                      </div>
                                    </div>
                                    <div class="col-12">
                                      <div class="text-center">
                                        <a v-if="item.attachment" :href="config.base_url_for_Image +
                                          item.attachment
                                          " target="_blank" class="
                                            btn btn-primary btn-sm
                                            mr-3
                                            mt-4
                                          ">Download</a>
                                        <a href="#" data-toggle="modal" data-target="#share_medical_record_modal" class="
                                            btn btn-primary btn-sm
                                            mr-3
                                            mt-4
                                          " @click="shareRecord(item.name)">Share</a>
                                        <a href="#" data-toggle="modal" data-target="#unshare_medical_record_modal"
                                          class="btn btn-primary btn-sm mr-3 mt-4" @click="unshareRecord(item.name)"
                                          v-if="item.access_details.length > 0">Unshare</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h5 v-if="medical_records.length === 0 && !showspinner
                              " class="No_data">
                              No Medical Records Found
                            </h5>
                          </div>

                          <!-- pagination start -->
                          <div id="pagination" v-if="medical_records.length > 10">
                            <ul class="pagination justify-content-center">

                              <!-- "Previous" Button -->
                              <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                                <a href="#" class="page-link" aria-label="Previous"
                                  @click.prevent="updateCurrent(current - 1)">
                                  Previous
                                </a>
                              </li>

                              <!-- Pagination Links (Display 5 at a time) -->
                              <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                                'page-item',
                                current === page_index ? 'active' : ''
                              ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                                <a href="#" class="page-link" @click.prevent="updateCurrent(page_index)">
                                  {{ page_index }}
                                </a>
                              </li>

                              <!-- "Next" Button -->
                              <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                                ">
                                <a href="#" class="page-link" aria-label="Next"
                                  @click.prevent="updateCurrent(current + 1)">
                                  Next
                                </a>
                              </li>
                            </ul>
                          </div>
                          <!-- pagination end -->
                          <!-- /Medical Records Tab -->
                        </div>
                        <!-- Tab Content -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <layout-footer></layout-footer>
      </div>
    </div>
    <!-- Medical Records Modal -->
    <div class="modal fade custom-modal custom-medicalrecord-modal" id="add_medical_records_modal" style="display: none"
      data-select2-id="add_medical_records_modal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Medical Record</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <!-- <form id="medical_records_form"> -->
          <div class="modal-body doctor-profile">
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="form-group">
                  <label>Report Type</label>
                  <v-select class="mr-2" name="Report Type" required="" label="Report Type"
                    v-model="add_medical_record_data.report_type" placeholder="Select Report Type"
                    :options="report_types">
                  </v-select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-12">
                <div class="form-group">
                  <label>Doctor</label>

                  <v-select class="mr-2" name="name" required="" label="practitioner_name"
                    v-model="add_medical_record_data.doctor" placeholder="Select Doctor"
                    :reduce="(option) => option.name" :options="doctor_list">
                  </v-select>
                  <span v-if="doctor_list.length === 0">Add doctors to favourite for this</span>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Upload (Allowed Only JPG, PNG, JPEG, HEIC and PDF)</label>
                    <div class="upload-medical-records">
                      <input class="form-control" type="file" name="user_file" id="user_files_mr" @change="onFileChange" accept=".jpg, .jpeg, .png, .pdf, .heic" />
                      <div class="upload-content dropzone" v-if="add_medical_record_data.filename === ''">
                        <div class="text-center">
                          <div class="upload-icon mb-2">
                            <img src="@/assets/img/upload-icon.png" alt="" />
                          </div>
                          <h5>Drag &amp; Drop</h5>
                          <h6>or <span class="text-danger">Browse</span></h6>
                        </div>
                      </div>
                      <div class="upload-content dropzone" v-if="add_medical_record_data.filename !== ''">
                        <div class="text-center">
                          <div class="upload-icon mb-2">
                            <img style="width: 64px" src="@/assets/img/file.png" alt="" /><br />
                            {{ add_medical_record_data.filename }}
                          </div>
                          <h6><span class="text-danger">Replace</span></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>Document Description</label>
                  <textarea class="form-control" placeholder="Add document description" name="services"
                      v-model="add_medical_record_data.description" id="services"></textarea>
                  <!-- <input type="text" data-role="tagsinput" class="input-tags form-control"
                    placeholder="Add document description" name="services" v-model="add_medical_record_data.description"
                    id="services" /> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Date Of Document</label>
                  <div class="form-group">
                    <input type="date" class="form-control" name="tratment_date" id="tratment_date"
                      v-model="add_medical_record_data.date" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
              <div class="submit-section text-left">
                <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                  aria-label="Close" @click="add_new_medical_record()" :disabled="!isFileUploaded">
                  Submit
                </button>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
    <!-- /Medical Records Modal -->

    <!-- /Share Medical Records Modal -->
    <div class="modal fade custom-modal show" id="share_medical_record_modal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Share Medical Record</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body doctor-profile">
                <div class="row form-row">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Purpose</label>
                      <input v-model="share_medical_record.purpose" type="text" class="form-control" value="" />
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Doctor</label>
                      <v-select class="mr-2" name="name" required="" label="practitioner_name"
                        v-model="share_medical_record.doctor" placeholder="Select Doctor"
                        :reduce="(option) => option.name" :options="doctor_list">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Share Till</label>
                      <datepicker input-class="datepicker-here form-control digits" :format="format"
                        v-model="share_medical_record.upto" :disabled-dates="disabledDates"></datepicker>
                    </div>
                  </div>
                </div>
                <div class="submit-section" style="text-align: left">
                  <button @click="share_record()" :disabled="disabled" class="btn btn-primary submit-btn"
                    data-dismiss="modal" aria-label="Close">
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Share Medical Records Modal -->

    <!-- /UnShare Medical Records Modal -->
    <div class="modal fade custom-modal show" id="unshare_medical_record_modal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Unshare Medical Record</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body doctor-profile" v-if="shared_documents.length">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th class="text-left">Doctor</th>
                      <th class="text-left">Share till</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in shared_documents" :key="index">
                    <tr>
                      <th scope="row" class="text-center">
                        <input type="checkbox" @change="check($event, item.id)" />
                      </th>
                      <td class="text-left">{{ item.doctor_name }}</td>
                      <td class="text-left">{{ formatDate(item.upto) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="submit-section mt-3" style="text-align: left">
                  <button @click="unshare_record()" class="btn btn-primary submit-btn" data-dismiss="modal"
                    :disabled="unshared_documents.length === 0" aria-label="Close">
                    Unshare
                  </button>
                </div>
              </div>
              <h5 v-if="shared_documents.length === 0" class="No_data">
                No Records Found
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /UnShare Medical Records Modal -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import config from "../../../services/CommonApi";
import CommonApi from "../../../services/CommonApi";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      medical_records: [],
      doctor_list: [],
      belong_to: [],
      report_types: [],
      speciality: [],
      showspinner: true,
      disabled: true,
      config: config,
      shared_documents: [],
      unshared_documents: [],
      share_medical_record: {
        purpose: "",
        doctor: "",
        upto: new Date(),
        patient: this.$store.state.user.user_id,
        name: "",
      },
      datePickerOptions: {
        minDate: new Date(),
      },
      shared_id: "",
      add_medical_record_data: {
        patient: this.$store.state.user.user_id,
        doctor: "",
        belongs_to: "",
        filename: "",
        report_type: "",
        date: "",
        speciality: "",
        description: "",
        doc_type: "My Documents",
        decode_base64: 1,
        attached_to_field: "attachment",
        filedata: "",
      },
      current: 1,
      paginate: 12,
      paginate_total: 0,
    };
  },
  components: { Datepicker },
  computed: {

    isFileUploaded() {
      return this.add_medical_record_data.filename !== '';
    },

    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
    disabledDates() {
      const today = new Date();
      return {
        to: today, // Disable dates up to today (past dates)
      };
    },
    share_medical_data() {
      return this.share_medical_record.doctor && this.share_medical_record.upto;
    },
  },
  watch: {
    share_medical_data() {
      if (
        this.share_medical_record.doctor === null ||
        this.share_medical_record.upto === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  methods: {

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const year = date.getFullYear();
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    updateCurrent(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    /* Get Shared Record  */
    shareRecord(record) {
      this.share_medical_record.name = record;
    },

    check(event, id) {
      if (event.target.checked) {
        this.unshared_documents.push(id);
      } else {
        const index = this.unshared_documents.indexOf(id);
        if (index > -1) {
          this.unshared_documents.splice(index, 1);
        }
      }
    },

    /* Change Profile Image */
    onFileChange(event) {
    const fileInput = event.target;
    const selectedFile = fileInput.files[0];

    if (selectedFile) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf", "image/heic"];

      if (!allowedTypes.includes(selectedFile.type)) {
        alert("Upload (Allowed Only JPG, PNG, JPEG, HEIC and PDF)");
        fileInput.value = ''; // Clear the input to reset it
      } else {
        this.add_medical_record_data.filename = selectedFile.name;
        this.createImage(selectedFile);
      }
    }
  },

    /* Create Profile Image */
    createImage(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.add_medical_record_data.filename = file.name;
        this.add_medical_record_data.filedata = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    /* Add New Medical Record */
    async add_new_medical_record() {
      await CommonApi.post_data(
        "sahaj.document.upload_document",
        JSON.stringify(this.add_medical_record_data)
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.get_patient_documents();
          this.$emit("close");
          (this.add_medical_record_data.doctor = ""),
            (this.add_medical_record_data.belongs_to = ""),
            (this.add_medical_record_data.filename = ""),
            (this.add_medical_record_data.report_type = ""),
            (this.add_medical_record_data.date = "");
          this.add_medical_record_data.description = "";
          this.add_medical_record_data.filedata = "";
        }
      });
    },

    /* Get Unshared Record  */
    unshareRecord(record) {
      this.shared_documents = [];
      this.shared_id = record;
      this.get_shared_documents(record);
    },

    /* Get Patient Documents  */
    async get_patient_documents() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data(
        "sahaj.document.get_patient_documents",
        params
      ).then((res) => {
        this.showspinner = false;
        this.medical_records = res.data;
        this.paginate_total = Math.ceil(
          this.medical_records.length / this.paginate
        );
      });
    },

    // async get_my_doctor() {
    //   const params = new URLSearchParams();
    //   params.append("patient", this.user_id);
    //   await CommonApi.get_data("sahaj.finalapi.get_doctor_list_v2", params).then(
    //     (res) => {
    //       this.showspinner = false;
    //       if (res && res.data) {
    //         this.doctor_list = res.data
    //       }
    //     }
    //   );
    // },


        /* Get My Doctors  */
    async get_my_doctor() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data("sahaj.api.get_my_doctors", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.doctor_list = res.data.filter((data) => data.is_favorite !== 0);
          }
        }
      );
    },

    /* Get Belong To  */
    async get_belongs_to() {
      await CommonApi.get_data("sahaj.document.get_belongs_to").then((res) => {
        this.showspinner = false;
        if (res) {
          this.belong_to = res.message;
        }
      });
    },

    /* Get Report Types  */
    async get_document_report_type() {
      await CommonApi.get_data("sahaj.document.get_document_report_type").then(
        (res) => {
          this.showspinner = false;
          if (res) {
            this.report_types = res.message;
          }
        }
      );
    },

    /* Get Speciality List  */
    async get_speciality_list() {
      await CommonApi.get_data("sahaj.api.get_speciality_list").then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.speciality = res.data;
        }
      });
    },

    /* Get Shared Documents */
    async get_shared_documents(record) {
      let data = {
        name: record,
      };
      await CommonApi.post_data(
        "sahaj.document.get_shared_documents",
        JSON.stringify(data)
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.shared_documents = res.data[0].access_given;
        }
      });
    },

    /* UnShare Medical record  */
    async unshare_record() {
      if (this.unshared_documents.length) {
        var bodyFormData = new FormData();
        bodyFormData.append(
          "access_remove",
          JSON.stringify(this.unshared_documents)
        );
        await CommonApi.post_data(
          "sahaj.document.unshare_medical_record_vb",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_documents();
            this.$emit("close");
            this.unshared_documents = [];
            this.shared_id = "";
          }
        });
      }
    },

    /* Share Medical record  */
    async share_record() {
      if (!this.disabled) {
        let data = {
          purpose: this.share_medical_record.purpose,
          doctor: this.share_medical_record.doctor,
          upto: this.share_medical_record.upto.toISOString().slice(0, 10),
          patient: this.share_medical_record.patient,
          name: this.share_medical_record.name,
        };
        await CommonApi.post_data(
          "sahaj.document.share_medical_record",
          data
        ).then((res) => {
          this.showspinner = false;
          if (res.status_code === 500) {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: res.message,
              showConfirmButton: true,
            });
          }
          else {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_documents();
            this.$emit("close");
            (this.share_medical_record.purpose = ""),
              (this.share_medical_record.doctor = ""),
              (this.share_medical_record.upto = ""),
              (this.share_medical_record.patient = ""),
              (this.share_medical_record.name = "");

          }
        });
      }
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_patient_documents();
    this.get_belongs_to();
    this.get_document_report_type();
    this.get_speciality_list();
    this.get_my_doctor();

    // Signup Toggle
    $(function () {
      $("#is_registered").click(function () {
        if ($(this).is(":checked")) {
          $("#preg_div").show();
        } else {
          $("#preg_div").hide();
        }
      });
    });

    //Increment Decrement value
    $(".inc.button").click(function () {
      var $this = $(this),
        $input = $this.prev("input"),
        $parent = $input.closest("div"),
        newValue = parseInt($input.val()) + 1;
      $parent.find(".inc").addClass("a" + newValue);
      $input.val(newValue);
      newValue += newValue;
    });
    $(".dec.button").click(function () {
      var $this = $(this),
        $input = $this.next("input"),
        $parent = $input.closest("div"),
        newValue = parseInt($input.val()) - 1;
      console.log($parent);
      $parent.find(".inc").addClass("a" + newValue);
      $input.val(newValue);
      newValue += newValue;
    });

    // Signup Profile
    function readURL(input) {
      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          $("#prof-avatar").attr("src", e.target.result);
        };

        reader.readAsDataURL(input.files[0]);
      }
    }
    $("#profile_image").change(function () {
      readURL(this);
    });

    // Datepicker
    var maxDate = $("#maxDate").val();
    if ($("#dob").length > 0) {
      $("#dob").datepicker({
        startView: 2,
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: maxDate,
      });
    }
    if ($("#editdob").length > 0) {
      $("#editdob").datepicker({
        startView: 2,
        format: "dd/mm/yyyy",
        autoclose: true,
        todayHighlight: true,
        endDate: maxDate,
      });
    }

    // Select 2

    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/MedicalRecords.vue